module.exports = __webpack_public_path__ + "img/86039303.436ef81c.png";